import './Search.css';

import { Component } from 'react';

import LTEBox from 'containers/LTEBox';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { withAppProps } from 'utils/react/withAppProps';
import findResults from './findResults';

@withAppProps
class Search extends Component {
  static propTypes = {
    location: PropTypes.object,
    menuTree: PropTypes.array,
    msg: PropTypes.object,
    auth: PropTypes.object,
    searchParams: PropTypes.object.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return this.props.location.search !== nextProps.location.search;
  }

  getBreadcrumbs = (crumb) => {
    let res = crumb.getName();
    let parent = crumb;
    while (parent?.hasParent()) {
      parent = parent.getParent();
      res = `${parent.getName()} > ${res}`;
    }
    return res;
  };

  getResults = () => {
    const {
      searchParams,
      msg,
      auth: { scope },
      menuTree,
    } = this.props;
    const q = searchParams.get('q');
    try {
      const results = findResults({
        q: q.toLowerCase(),
        menuTree,
        scope,
      });
      if (!results || !results.size) {
        return msg.search.noResults;
      }
      return results
        .filter(this.filterResults)
        .sort(this.sortResults)
        .map((result) => {
          const breadCrumbs = this.getBreadcrumbs(result.breadCrumb);
          return (
            <div key={breadCrumbs}>
              <Link to={result.url} className='search__result'>
                <h3 className='m-0 text-gray-900'>
                  {result.boxTitle || result.label || result.title}
                </h3>
                <p className='m-0 py-1'>{breadCrumbs}</p>
                {result.description && Array.isArray(result.description) ? (
                  result.description.map((description) => (
                    <div
                      key={description}
                      className='search__multiline-description'
                    >
                      {description}
                    </div>
                  ))
                ) : (
                  <div className='m-0 text-gray-900'>
                    <ReactMarkdown>{result.description}</ReactMarkdown>
                  </div>
                )}
              </Link>
            </div>
          );
        });
    } catch {
      return <div>{msg.search.errorOccured}</div>;
    }
  };

  filterResults = (result, _index, results) => {
    const foundResultsWithSameUrl = results.filter(
      (res) => res.url === result.url,
    );
    return (
      foundResultsWithSameUrl.size === 1 ||
      Math.min(
        ...foundResultsWithSameUrl.map((res) => res.significance).toJS(),
      ) < result.significance
    );
  };

  sortResults = (a, b) => b.significance - a.significance;

  render() {
    const {
      searchParams,
      msg: { search: msg },
      auth: { scope },
    } = this.props;
    if (!scope) {
      return null;
    }
    const q = searchParams.get('q');
    if (!q) {
      return (
        <div className='m-4'>
          <LTEBox
            bodyComponent={<div>{msg.emptySearch}</div>}
            className='box box-primary'
            title={msg.titleEmptySearch}
          />
        </div>
      );
    }
    return (
      <div className='m-4'>
        <LTEBox
          bodyComponent={<div>{this.getResults()}</div>}
          className='box box-primary'
          title={msg.title.replace('{q}', q)}
        />
      </div>
    );
  }
}

export default Search;
